import { addDays, differenceInDays, Interval, isAfter, isWithinInterval } from 'date-fns';
import { getMidnightFromString } from '../../../../../../utils';

import type { DateCell } from '../../types';
import type { Nights } from '@lt/api/dist/types/searchParams';

export const isBetweenDates = (
  date: Date,
  interval: { start?: Date | null; end?: Date | null }
): boolean => {
  if (!interval.start || !interval.end) return false;

  return isWithinInterval(date, interval as Interval);
};

export const isSmallShift = (shift: number): boolean => {
  return shift < 2;
};

/* TODO: Эта группа TODO будем искать их по ключевому слову СПАСИТЕ ниже описание
export const getShiftFromFlexDates = (flexDates: FlexDates): DateCell['shift'] => {
  const { from, to, primary } = flexDates;

  return {
    left: differenceInDays(primary, from),
    right: differenceInDays(to, primary),
  };
};
*/

export const getCornerDates = ({
  date,
  shift,
}: {
  date: Date | string | null;
  shift: number;
}): CornerDates => {
  const formatDate = date instanceof Date ? date : new Date(date || 0);
  return {
    from: addDays(formatDate, -shift),
    to: addDays(formatDate, shift),
  };
};

export const getEndDateFrom = (
  startCornerDates: CornerDates,
  nights: Nights,
  isFlexNights: boolean
): Date => {
  if (isFlexNights) {
    return addDays(startCornerDates.to, nights.from);
  }
  return addDays(startCornerDates.from, nights.from);
};

export const getEndDateTo = (
  startCornerDates: CornerDates,
  nights: Nights,
  isFlexNights: boolean
): Date => {
  if (isFlexNights) {
    return addDays(startCornerDates.from, nights.to);
  }
  return addDays(startCornerDates.to, nights.to);
};

export const getFlexEndDatesFromNights = (
  startDateCell: DateCell,
  shift: number,
  nights: Nights
): CornerDates & { primary: Date | null } => {
  const startCornerDates = getCornerDates({
    date: startDateCell.date,
    shift,
  });
  const isFlexNights = nights.from !== nights.to;

  const from = getEndDateFrom(startCornerDates, nights, isFlexNights);
  const to = getEndDateTo(startCornerDates, nights, isFlexNights);
  const isFromAfterTo = isAfter(from, to);

  return {
    from,
    to,
    primary: isFromAfterTo
      ? null
      : new Date(getMidnightFromString((from.getTime() + to.getTime()) / 2)),
  };
};

export const getRangeNightsString = ({
  startDateCell,
  endDateCell,
}: {
  startDateCell: DateCell;
  endDateCell: DateCell;
}): Nights | undefined => {
  const { date: startDate } = startDateCell;
  const { date: endDate } = endDateCell;

  if (!startDate || !endDate) {
    return;
  }

  return {
    from: differenceInDays(endDate, startDate),
    to: differenceInDays(endDate, startDate),
  };
};

export type CornerDates = {
  from: Date;
  to: Date;
};

export type FlexDates = CornerDates & {
  primary: Date;
};
